import { useTranslation } from "react-i18next";
import {
  useCreateEssentialQuestions,
  useGetEssentialQuestions,
  getEssentialQuestions,
} from "@packages/api/madlenAPI";
import { EssentialQuestionsResponseDto } from "@packages/api/madlenAPI.schemas";
import CreateModal, {
  CreateModalProps,
} from "../../../components/create-modal";
import { EssentialQuestionsCard } from "../../../components/essential-questions/EssentialQuestionsCard";
import GenericToolCreationPage from "../../../components/tool_components/GenericToolCreationPage";
import i18n from "@packages/i18n/config";

const CreateEssentialQuestionsView = () => {
  const { t } = useTranslation();

  const CreateModalWrapper = ({
    initialInput,
    onSubmit,
    isLoading,
    error,
  }: Partial<CreateModalProps>) => (
    <CreateModal
      title={t("quickActions.essentialQuestionsCreate")}
      backPath="/content/essential-questions"
      themeColor="lavender"
      loadingTitle={t("essentialQuestions.result.loading.title")}
      errorTitle={t("essentialQuestions.submit.error.title")}
      errorDescription={t("essentialQuestions.submit.error.description")}
      submitButtonText={t("common.generate")}
      initialInput={initialInput!}
      onSubmit={async (input) => {
        await onSubmit!(input);
      }}
      isLoading={isLoading!}
      error={error!}
      placeholder={t("essentialQuestions.placeholder")}
    />
  );

  const ToolCardWrapper = ({
    toolData,
    isImageLoading,
    onCreateAgain,
  }: {
    toolData: EssentialQuestionsResponseDto;
    isImageLoading: boolean;
    onCreateAgain: () => void;
  }) => {
    return (
      <EssentialQuestionsCard
        id={toolData.id}
        author={toolData.authorName || ""}
        description={toolData.description || ""}
        title={toolData.title || ""}
        courseName={toolData.courseName || ""}
        gradeLevel={toolData.gradeLevel || 0}
        imageUrl={toolData.imageUrl || ""}
        questions={toolData.questions || []}
        activitySuggestions={toolData.activitySuggestions || []}
        isImageLoading={isImageLoading}
        topic={toolData.prompt || ""}
        createdAt={toolData.createdAt ?? ""}
        onCreateAgain={onCreateAgain}
        contentLanguage={toolData.contentLanguage || i18n.language}
      />
    );
  };

  return (
    <GenericToolCreationPage
      toolType="essentialQuestions"
      useCreateTool={useCreateEssentialQuestions}
      useGetTool={useGetEssentialQuestions}
      getTool={getEssentialQuestions}
      ToolCard={ToolCardWrapper}
      CreateModalWrapper={CreateModalWrapper}
      toolDataExtractor={(data: EssentialQuestionsResponseDto) =>
        data?.questions
      }
    />
  );
};

export default CreateEssentialQuestionsView;
